import { Channel } from '@/types/channel';
import { Get } from './helpers';

export const GetChannels = (): Promise<Channel[]> => {
  return Get<Channel[]>({ url: '/v3/admin/auth/channels' });
};
